export const address = "DYNAMIC" as "DYNAMIC";

export const abi = [
	{
		type: "function",
		name: "PRECISION",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "pure",
	},
	{
		type: "function",
		name: "accruedBrktTvlFees",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "accruedManagerPerformanceFees",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "int256",
				internalType: "int256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "accruedManagerTvlFees",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "allowance",
		inputs: [
			{
				name: "owner",
				type: "address",
				internalType: "address",
			},
			{
				name: "spender",
				type: "address",
				internalType: "address",
			},
		],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "approve",
		inputs: [
			{
				name: "spender",
				type: "address",
				internalType: "address",
			},
			{
				name: "value",
				type: "uint256",
				internalType: "uint256",
			},
		],
		outputs: [
			{
				name: "",
				type: "bool",
				internalType: "bool",
			},
		],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "assetsPerShare",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "balanceOf",
		inputs: [
			{
				name: "account",
				type: "address",
				internalType: "address",
			},
		],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "claimBrktTvlFees",
		inputs: [],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "claimManagerPerformanceFees",
		inputs: [],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "claimManagerTvlFees",
		inputs: [],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "claimWithdrawal",
		inputs: [
			{
				name: "shares",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "claimEpoch",
				type: "uint16",
				internalType: "uint16",
			},
			{
				name: "timestamp",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "salt",
				type: "bytes32",
				internalType: "bytes32",
			},
		],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "convertToAssets",
		inputs: [
			{
				name: "shares",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "_assetsPerShare",
				type: "uint256",
				internalType: "uint256",
			},
		],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "pure",
	},
	{
		type: "function",
		name: "convertToShares",
		inputs: [
			{
				name: "assets",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "_assetsPerShare",
				type: "uint256",
				internalType: "uint256",
			},
		],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "pure",
	},
	{
		type: "function",
		name: "deposit",
		inputs: [
			{
				name: "assets",
				type: "uint256",
				internalType: "uint256",
			},
		],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "epoch",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "uint16",
				internalType: "uint16",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "getWithdrawalStatusAndHash",
		inputs: [
			{
				name: "user",
				type: "address",
				internalType: "address",
			},
			{
				name: "amount",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "claimEpoch",
				type: "uint16",
				internalType: "uint16",
			},
			{
				name: "timestamp",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "salt",
				type: "bytes32",
				internalType: "bytes32",
			},
		],
		outputs: [
			{
				name: "",
				type: "uint8",
				internalType: "enum IBracketVault.WithdrawalStatus",
			},
			{
				name: "",
				type: "bytes32",
				internalType: "bytes32",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "grantRole",
		inputs: [
			{
				name: "role",
				type: "bytes32",
				internalType: "bytes32",
			},
			{
				name: "account",
				type: "address",
				internalType: "address",
			},
		],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "hashWithdrawal",
		inputs: [
			{
				name: "user",
				type: "address",
				internalType: "address",
			},
			{
				name: "claimEpoch",
				type: "uint16",
				internalType: "uint16",
			},
			{
				name: "shares",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "timestamp",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "salt",
				type: "bytes32",
				internalType: "bytes32",
			},
		],
		outputs: [
			{
				name: "",
				type: "bytes32",
				internalType: "bytes32",
			},
		],
		stateMutability: "pure",
	},
	{
		type: "function",
		name: "lastDeposit",
		inputs: [
			{
				name: "user",
				type: "address",
				internalType: "address",
			},
		],
		outputs: [
			{
				name: "",
				type: "uint16",
				internalType: "uint16",
			},
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "pendingDepositShares",
		inputs: [
			{
				name: "account",
				type: "address",
				internalType: "address",
			},
		],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "sharesOf",
		inputs: [
			{
				name: "account",
				type: "address",
				internalType: "address",
			},
		],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "startVault",
		inputs: [],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "totalActiveShares",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "totalDeposits",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "totalSupply",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "totalWithdrawals",
		inputs: [
			{
				name: "epoch",
				type: "uint16",
				internalType: "uint16",
			},
		],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "transfer",
		inputs: [
			{
				name: "to",
				type: "address",
				internalType: "address",
			},
			{
				name: "value",
				type: "uint256",
				internalType: "uint256",
			},
		],
		outputs: [
			{
				name: "",
				type: "bool",
				internalType: "bool",
			},
		],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "transferFrom",
		inputs: [
			{
				name: "from",
				type: "address",
				internalType: "address",
			},
			{
				name: "to",
				type: "address",
				internalType: "address",
			},
			{
				name: "value",
				type: "uint256",
				internalType: "uint256",
			},
		],
		outputs: [
			{
				name: "",
				type: "bool",
				internalType: "bool",
			},
		],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "isVaultLocked",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "bool",
				internalType: "bool",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "updateNav",
		inputs: [
			{
				name: "newNav",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "managerPerformanceFee",
				type: "int256",
				internalType: "int256",
			},
			{
				name: "managerTvlFee",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "brktTvlFee",
				type: "uint256",
				internalType: "uint256",
			},
		],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "updateVanityNav",
		inputs: [
			{
				name: "newNav",
				type: "uint256",
				internalType: "uint256",
			},
		],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "vanityNav",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "withdraw",
		inputs: [
			{
				name: "assets",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "salt",
				type: "bytes32",
				internalType: "bytes32",
			},
		],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "withdrawDelay",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "uint16",
				internalType: "uint16",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "withdrawableAssets",
		inputs: [
			{
				name: "account",
				type: "address",
				internalType: "address",
			},
		],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "event",
		name: "Approval",
		inputs: [
			{
				name: "owner",
				type: "address",
				indexed: true,
				internalType: "address",
			},
			{
				name: "spender",
				type: "address",
				indexed: true,
				internalType: "address",
			},
			{
				name: "value",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
		],
		anonymous: false,
	},
	{
		type: "event",
		name: "ClaimedWithdrawal",
		inputs: [
			{
				name: "user",
				type: "address",
				indexed: true,
				internalType: "address",
			},
			{
				name: "withdrawalId",
				type: "bytes32",
				indexed: false,
				internalType: "bytes32",
			},
			{
				name: "shares",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
			{
				name: "assets",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
			{
				name: "remainingAssets",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
		],
		anonymous: false,
	},
	{
		type: "event",
		name: "NavUpdated",
		inputs: [
			{
				name: "epoch",
				type: "uint256",
				indexed: true,
				internalType: "uint256",
			},
			{
				name: "nav",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
			{
				name: "clearedDeposits",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
			{
				name: "clearedWithdrawals",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
			{
				name: "managerPerformanceFee",
				type: "int256",
				indexed: false,
				internalType: "int256",
			},
			{
				name: "managerTvlFee",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
			{
				name: "brktTvlFee",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
		],
		anonymous: false,
	},
	{
		type: "event",
		name: "PendingDeposit",
		inputs: [
			{
				name: "user",
				type: "address",
				indexed: true,
				internalType: "address",
			},
			{
				name: "assets",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
			{
				name: "epoch",
				type: "uint16",
				indexed: false,
				internalType: "uint16",
			},
		],
		anonymous: false,
	},
	{
		type: "event",
		name: "ScheduledWithdrawal",
		inputs: [
			{
				name: "user",
				type: "address",
				indexed: true,
				internalType: "address",
			},
			{
				name: "shares",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
			{
				name: "claimEpoch",
				type: "uint16",
				indexed: false,
				internalType: "uint16",
			},
			{
				name: "timestamp",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
			{
				name: "salt",
				type: "bytes32",
				indexed: false,
				internalType: "bytes32",
			},
		],
		anonymous: false,
	},
	{
		type: "event",
		name: "Transfer",
		inputs: [
			{
				name: "from",
				type: "address",
				indexed: true,
				internalType: "address",
			},
			{
				name: "to",
				type: "address",
				indexed: true,
				internalType: "address",
			},
			{
				name: "value",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
		],
		anonymous: false,
	},
	{
		type: "event",
		name: "VanityNavUpdated",
		inputs: [
			{
				name: "epoch",
				type: "uint256",
				indexed: true,
				internalType: "uint256",
			},
			{
				name: "newNav",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
		],
		anonymous: false,
	},
	{
		type: "event",
		name: "VaultStarted",
		inputs: [
			{
				name: "totalDeposits",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
		],
		anonymous: false,
	},
	{
		type: "error",
		name: "FeeClaimInterval",
		inputs: [],
	},
	{
		type: "error",
		name: "InsufficientBalance",
		inputs: [],
	},
	{
		type: "error",
		name: "InvalidLength",
		inputs: [],
	},
	{
		type: "error",
		name: "InvalidWithdrawalDelay",
		inputs: [],
	},
	{
		type: "error",
		name: "NoDeposits",
		inputs: [],
	},
	{
		type: "error",
		name: "VaultAlreadyStarted",
		inputs: [],
	},
	{
		type: "error",
		name: "VaultLocked",
		inputs: [],
	},
	{
		type: "error",
		name: "VaultNotLocked",
		inputs: [],
	},
	{
		type: "error",
		name: "VaultNotStarted",
		inputs: [],
	},
	{
		type: "error",
		name: "WithdrawalAlreadyQueued",
		inputs: [],
	},
	{
		type: "error",
		name: "WithdrawalNotReady",
		inputs: [],
	},
	{
		type: "error",
		name: "ZeroAddress",
		inputs: [],
	},
	{
		type: "error",
		name: "ZeroAmount",
		inputs: [],
	},
] as const;
